/**
 *  App component
 *
 *  @author    2024        源?⑤?
 *  @author    2026-04-23  Bruce.Cheong    (?붿옄??媛쒖꽑)
 */

/** External import */
import { useEffect, useRef, useState } from 'react';
import { Routes, Route, Navigate, useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { create } from "zustand";


/** Internal import */
import CSS from "./App.module.css";

import { appVersionManagerClass, backPointUrlManagerClass, deleteAllCookies, setCookie, webViewBridgeClass } from './Common/ts/appTools';
import { getAccountData, isMaintenancePageOn, openInExternalBrowser, whatIsMode, whichBrowserDoYouUse } from './Common/ts/commonTools';
import { MYSTUDIO_AUTH_REQUIRED_EVENT, MystudioApiError, mystudioV4 } from './Common/api/v4/client';
import { isPreviewDataAllowed, isPublicPasswordlessDemoSession } from './Common/api/v4/previewGuard';
import { getLegacyProductRedirect } from './Common/routes/customerRouteCutover';

// 怨듭슜 ?섏씠吏
import Login from './PublicPage/Login/Login';
import Header from './PublicPage/Header/Header';


import ResetUserPassword from './PublicPage/ResetUserPassword/ResetUserPassword';

import ThemeBookHome from './PublicPage/ThemeBook/ThemeBookHome';

import ThemeBookManagement from './AdminPage/ThemeBookManagement/ThemeBookManagement';

import DeleteURL from './PublicPage/DeleteURL/DeleteURL';
import TestPage from './TestPage/TestPage';
import Toast from './Component/Elements/Toast/Toast';
import CustomerNavi from './PublicPage/Navi/CustomerNavi';
import AdminNavi from './PublicPage/Navi/AdminNavi';
import RedirectToAnotherBrowser from './PublicPage/RedirectToAnotherBrowser/RedirectToAnotherBrowser';
import { mobileBackgroundColorType } from './Common/interface/style.interface';
import { BROWSER_CODE } from './Common/ts/const';
import MaintenancePage from './PublicPage/MaintenancePage/MaintenancePage';
import { RTN_interface } from './Common/interface/App.interface';
import useAlarmNewCountREST from './PublicPage/Header/hooks/useAlarmNewCountREST.hook';
import useAlarmListREST from './PublicPage/Header/hooks/useAlarmListREST.hook';
import { ErrorBoundaryRapper } from './Component/Elements/ErrorBoundaries/ErrorBoundaryRapper';
import ErrorBoundary from './Component/Elements/ErrorBoundaries/ErrorBoundary';

import FigmaProductApplyPage from './components/ProductApplyPage/ProductApplyPage';
import FigmaHomePage from './components/HomePage/HomePage';
import FigmaMyPage from './components/FigmaMyPage';
import MyPhotoArchivePage from './components/MyPhotoArchive/MyPhotoArchive';
import MobileMyPageDocuments from './components/MyPageDocuments/MobileMyPageDocuments';
import { AppSettingsPage, TermsPage } from './components/MyPageSettings/MyPageSettingsPage';
import FigmaShootingSchedulePage from './components/ShootingSchedulePage/ShootingSchedulePage';
import FigmaShootingThemePage from './components/ShootingThemePage/ShootingThemePage';
import ProductPhotoSelectPage from './components/ProductPhotoSelectPage/ProductPhotoSelectPage';
import ChangePassword from './CustomerPage/ChangePassword/ChangePassword';
import MyInfo from './CustomerPage/MyInfo/MyInfo';  // MyPage???덈줈 留뚮뱾怨?MyInfo濡??泥?Bruce.Cheong 2026-05-06)

/** My Home(New) Bruce.Choeng (2026-04-27) */
import QnaList from './CustomerPage/Qna/QnaList';
import FaqList from './CustomerPage/Faq/FaqList';


const webViewBridge = new webViewBridgeClass();

const appVersionManager = new appVersionManagerClass();

const backPointUrlManager = new backPointUrlManagerClass();
type PreviewDeviceType = "mobile" | "tablet" | null;
const RESPONSIVE_PREVIEW_TABLET_QUERY = "(min-width: 700px)";
const PREVIEW_DEVICE_QUERY_KEYS = ["view", "device", "preview"] as const;

function getPreviewDeviceFromPath(pathname: string): PreviewDeviceType {
    if(pathname === "/mobile"){
        return "mobile";
    }

    if(pathname === "/tablet"){
        return "tablet";
    }

    return null;
}

function isFirstPreviewLoginPath(pathname: string, previewDevice: PreviewDeviceType): boolean {
    return pathname === "/" || (Boolean(previewDevice) && ["/mobile", "/tablet"].includes(pathname));
}

function getSearchWithoutPreviewDeviceParams(search: string): string | null {
    const nextParams = new URLSearchParams(search);
    let hasPreviewDeviceParam = false;

    PREVIEW_DEVICE_QUERY_KEYS.forEach((key) => {
        if(nextParams.has(key)){
            hasPreviewDeviceParam = true;
            nextParams.delete(key);
        }
    });

    if(!hasPreviewDeviceParam){
        return null;
    }

    const nextSearch = nextParams.toString();
    return nextSearch ? `?${nextSearch}` : "";
}

type commonState_Type = {
    isHeaderHidden: boolean;
    headerLeftNode: React.ReactNode | null;
    mobileHeaderTitle: string;
    headerRightNode: React.ReactNode | null;
    headerBackgroundColorPreset: mobileBackgroundColorType;
    isNaviHidden: boolean;
}

type commonStateSetter_Type = {
    setIsHeaderHidden: (value: boolean) => void;
    setHeaderLeftNode: (value: React.ReactNode | null) => void;
    setMobileHeaderTitle: (value: string) => void;
    setHeaderRightNode: (value: React.ReactNode | null) => void;
    setHeaderBackgroundColorPreset: (value: mobileBackgroundColorType) => void;
    setIsNaviHidden: (value: boolean) => void;
}

export const useCommonStore = create<commonState_Type & commonStateSetter_Type>((set) => ({
    isHeaderHidden: false,
    headerLeftNode: null,
    mobileHeaderTitle: "",
    headerRightNode: null,
    headerBackgroundColorPreset: "",
    isNaviHidden: false,

    setIsHeaderHidden: (value: boolean) => set({isHeaderHidden: value}),
    setHeaderLeftNode: (value: React.ReactNode | null) => set({headerLeftNode: value}),
    setMobileHeaderTitle: (value: string) => set({mobileHeaderTitle: value}),
    setHeaderRightNode: (value: React.ReactNode | null) => set({headerRightNode: value}),
    setHeaderBackgroundColorPreset: (value: mobileBackgroundColorType) => set({headerBackgroundColorPreset: value}),
    setIsNaviHidden: (value: boolean) => set({isNaviHidden: value}),
}))

function App() {

    // ?묒냽???섍꼍??移댁뭅?ㅽ넚, ?쇱씤 ?몄빋釉뚮씪?곗???寃쎌슦 ?몃? 釉뚮씪?곗??먯꽌 ?대━寃??쒕떎.
    openInExternalBrowser.auto_open();

    const pageRouterCode_obj = {
        none: 0,
        login: 1,
        customer: 2,
        admin: 3,
    } as const;

    type pageRouterCode_type = typeof pageRouterCode_obj [keyof typeof pageRouterCode_obj];

    const isLocalHostPreview = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    const isExplicitLocalPreview = isPreviewDataAllowed();
    const isPublicDemoSession = isPublicPasswordlessDemoSession({ token: getAccountData.token() });
    const initialSearchParams = new URLSearchParams(window.location.search);
    const initialPreviewDevice = getPreviewDeviceFromPath(window.location.pathname);
    const isForcedLoginRoute = initialSearchParams.get("screen") === "login";
    const isFirstPreviewLoginRoute =
        isExplicitLocalPreview
        && isFirstPreviewLoginPath(window.location.pathname, initialPreviewDevice);
    const [pageRouterCode, setPageRouterCode] = useState<pageRouterCode_type>(
        isForcedLoginRoute
            ? pageRouterCode_obj.login
            : isFirstPreviewLoginRoute ? pageRouterCode_obj.login
            : pageRouterCode_obj.none
    );

    const isHeaderHidden = useCommonStore((state) => state.isHeaderHidden);
    const headerLeftNode = useCommonStore((state) => state.headerLeftNode);
    const mobileHeaderTitle = useCommonStore((state) => state.mobileHeaderTitle);
    const headerRightNode = useCommonStore((state) => state.headerRightNode);
    const headerBackgroundColorPreset = useCommonStore((state) => state.headerBackgroundColorPreset);
    const isNaviHidden = useCommonStore((state) => state.isNaviHidden);

    const [URLSearchParamsValue, SetURLSearchParamsValue] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const localPreviewPath = URLSearchParamsValue.get("previewPath");
    const isFigmaProductApplyRoute = ["/tabs/products", "/productList", "/productRequestEdit"].includes(location.pathname);
    const isFigmaHomeRoute = ["/tabs/home"].includes(location.pathname);
    const isFigmaMyPageRoute = ["/tabs/mypage", "/mypage/photos", "/mypage/contract-docs", "/mypage/payment-history", "/mypage/receipts", "/mypage/app-settings", "/mypage/terms", "/myInfo"].includes(location.pathname);
    const isFigmaScheduleRoute = ["/tabs/schedules"].includes(location.pathname);
    const isFigmaThemeRoute = ["/tabs/themes"].includes(location.pathname);
    const isFigmaMobileQnaRoute = location.pathname === "/qnaList" || location.pathname.startsWith("/qnaList/") || location.pathname === "/faqList" || location.pathname.startsWith("/faqList/");
    const isFigmaFullScreenRoute = isFigmaProductApplyRoute || isFigmaHomeRoute || isFigmaMyPageRoute || isFigmaScheduleRoute || isFigmaThemeRoute || isFigmaMobileQnaRoute;

    // ?ㅼ젣濡?而⑦뀗痢좊뱾??異쒕젰?섎뒗 ?곸뿭??ref
    const containerRef = useRef<HTMLDivElement>(null);

    // ?쒕쾭 媛쒕컻以??섏뿉吏 異쒕젰 ?щ?
    const l_isMaintenancePageOn = isMaintenancePageOn();

    async function sendDeviceInfo(){
        if(isExplicitLocalPreview || isPublicDemoSession){
            return;
        }

        // flutter??紐⑤컮?쇨린湲?怨좎쑀 ?좏겙媛믪쓣 ?붿껌
        const m_deviceToken_data = await webViewBridge.getAuthToken();

        SendDeviceData:{
            // flutter?먯꽌 ?뺤긽?곸쑝濡??좏겙???뺣낫??寃쎌슦?먮쭔 ?쒕쾭濡??붿껌??蹂대궦??(利??뱁솚寃??깆씪?뚮뒗 ?숈옉 ?덊븿)
            if(!m_deviceToken_data.sign || !m_deviceToken_data.data){
                break SendDeviceData;
            }

            try{
                await mystudioV4.saveDevice(m_deviceToken_data.data.fcmToken);
            }catch{
                // Device registration must not invalidate a valid login.
            }

            // 2026-02-12 ???ъ궗瑜??꾪빐 ??踰꾩쟾 泥댄겕 湲곕뒫 以묐떒
            // 踰꾩쟾 泥댄겕
            // if(process.env.REACT_APP_MODE === "PRODUCT"){
            //     if(m_deviceToken_data.data.appVersion){
            //         // flutter??app??理쒖떊 踰꾩쟾 ?뺣낫瑜??섍릿??
            //         await webViewBridge.checkAppVersion(appVersionManager.latestAppVersion);
            //     }else{
            //         // App Version愿由??⑥튂媛 ?곸슜?섏? ?딅뒗 app?ъ슜?먭? ?덉쓣 寃쎌슦瑜??鍮꾪븯???대떦寃쎌슦?먮쭔 alert?앹꽦
            //         alert("OOPS??踰꾩쟾????뒿?덈떎.\n\nOOPS瑜?理쒖떊 踰꾩쟾?쇰줈 ?낅뜲?댄듃??二쇱꽭??");
            //     }
            // }
        }
    }

    // ?좏겙???쒕쾭濡?蹂대궡??寃利앺븯???⑥닔.
    async function authTokenChecker(token: string){
        const RTN: RTN_interface<number> = {
            sign: false,
            data: 0,
            msg: ""
        }

        IsHaveToken:{
            if(!token){
                RTN.sign = true;
                RTN.data = -1;
                RTN.msg = "have not token";
                break IsHaveToken;
            }
        }

        let l_data: {
            result: {
                msg: string;
                user_type: "C" | "E" | "O";
                name: string;
                user_id: string | number;
                office_id: string | number;
                office_name: string;
            };
        } | null = null;
        AccountDataReqeuset:{
            if(RTN.sign){
                break AccountDataReqeuset;
            }

            // ?좏겙媛?寃利?
            try{
                const response = await mystudioV4.myPage();
                const account = response.data;
                l_data = {
                    result: {
                        msg: "valid",
                        user_type: "C",
                        name: String(
                            account.displayName ?? account.display_name
                            ?? account.customerName ?? account.customer_name ?? "",
                        ),
                        user_id: account.customerId ?? account.customer_id
                            ?? account.memberId ?? account.member_id ?? "",
                        office_id: account.officeId ?? account.office_id
                            ?? account.office?.id ?? "",
                        office_name: String(
                            account.studioName ?? account.studio_name
                            ?? account.office?.name ?? "",
                        ),
                    },
                };

                if(!response){
                    RTN.sign = true;
                    RTN.data = -2;
                    RTN.msg = "empty reponse";

                    break AccountDataReqeuset;
                }

                if(!response.data){
                    RTN.sign = true;
                    RTN.data = -3;
                    RTN.msg = "not nomal response";

                    break AccountDataReqeuset;
                }
            }catch(error){
                if(error instanceof MystudioApiError && error.kind === "authentication"){
                    deleteAllCookies();
                    RTN.sign = true;
                    RTN.data = -3;
                    RTN.msg = "invalid token";
                }else{
                    setPageRouterCode(pageRouterCode_obj.customer);
                    return;
                }
            }
        }

        CheckAccountData:{
            if(RTN.sign){
                break CheckAccountData;
            }

            if(l_data === null){
                RTN.sign = true;
                RTN.data = -4;
                RTN.msg = "response data is null";

                break CheckAccountData;
            }

            if(l_data.result.msg !== "valid"){
                RTN.sign = true;
                RTN.data = -5;
                RTN.msg = "invalid token";

                break CheckAccountData;
            }
        }

        // ??議곌굔?쇰줈 泥섎━?섎뒗寃??먯껜媛 ?섎?媛 ?놁쓣寃껋쓣 ?앷컖?댁빞?쒕떎.
        if(RTN.sign){
            deleteAllCookies();
        }

        // ?좏겙 寃利앷낵?뺤뿉???덈줈諛쏆? ?좎? ???
        const m_new_user_type = l_data?.result.user_type || "";

        SetAccountData:{
            if(RTN.sign || !l_data){
                break SetAccountData;
            }

            // 紐⑤컮?쇳솚寃쎌씪寃쎌슦 湲곌린 怨좎쑀 ?좏겙媛믪쓣 ?쒕쾭濡?蹂대궦??
            await sendDeviceInfo();


            const m_days:number = 0;

            setCookie({name: "user_type", value: m_new_user_type, days: m_days});
            setCookie({name: "name", value: l_data.result.name, days: m_days});
            setCookie({name: "user_id", value: `${l_data.result.user_id || ""}`, days: m_days});
            setCookie({name: "office_id", value: `${l_data.result.office_id || ""}`, days: m_days});
            setCookie({name: "office_name", value: l_data.result.office_name, days: m_days});

            RTN.sign = true;
            RTN.data = 1;
            RTN.msg = "success";
        }

        SetPage:{
            if(RTN.data < 1){
                setPageRouterCode(pageRouterCode_obj.login);
                break SetPage;
            }

            switch(m_new_user_type){
                case "E" : // OOPS 愿由ъ옄
                case "O" : // ?쇰컲 吏곸썝
                    setPageRouterCode(pageRouterCode_obj.admin);
                    break;
                case "C":
                    setPageRouterCode(pageRouterCode_obj.customer);
                    break;
                default:
                    setPageRouterCode(pageRouterCode_obj.login);
            }
        }
    }

    // 二쇱냼??push_id媛 ?덈뒗 寃쎌슦, ?대떦 媛믪쓣 ?쒕쾭濡?蹂대깂
    function pushIdResponse(){
        const m_push_id = backPointUrlManager.getPushId(URLSearchParamsValue);

        if(!m_push_id){
            return;
        }

        const notificationId = Number(m_push_id);
        const request = Number.isSafeInteger(notificationId) && notificationId > 0
            ? mystudioV4.markNotificationsRead([notificationId])
            : Promise.resolve(null);

        request
        .then(() => {
            // ?깃났?대뜕, ?ㅽ뙣?? oops?먯꽌 痍⑦빐?쇳븷?숈옉? ?깊엳 ?녾쿋吏???

            // ?뚮┝ 紐⑸줉 媛깆떊
            alarmListRefetch();

            // ?뚮┝ 媛쒖닔 媛깆떊
            alarmNewCountRefetch();
        })
        .catch(() => undefined)
        .finally(() => {
            const newParams = new URLSearchParams(URLSearchParamsValue.toString());
            newParams.delete("push_id");

            SetURLSearchParamsValue(newParams, {replace: true});
        })
    }

    const {
        alarmNewCountRefetch,
    } = useAlarmNewCountREST(!isExplicitLocalPreview && !isPublicDemoSession);

    const {
        alarmListRefetch
    } = useAlarmListREST(!isExplicitLocalPreview && !isPublicDemoSession);

    useEffect(() => {
        if(!l_isMaintenancePageOn){
            if(isForcedLoginRoute){
                deleteAllCookies();
                setPageRouterCode(pageRouterCode_obj.login);
                return;
            }

            if(isFirstPreviewLoginRoute){
                setPageRouterCode(pageRouterCode_obj.login);
                return;
            }

            const m_token = getAccountData.token();
            if(isPublicPasswordlessDemoSession({ token: m_token })){
                setPageRouterCode(pageRouterCode_obj.customer);
                return;
            }
            authTokenChecker(m_token);
        }
    }, []);

    useEffect(() => {
        const onAuthenticationRequired = (event: Event) => {
            const status = (event as CustomEvent<{ status?: number }>).detail?.status;
            if(status !== 401){
                return;
            }
            deleteAllCookies();
            setPageRouterCode(pageRouterCode_obj.login);
        };

        window.addEventListener(MYSTUDIO_AUTH_REQUIRED_EVENT, onAuthenticationRequired);
        return () => {
            window.removeEventListener(MYSTUDIO_AUTH_REQUIRED_EVENT, onAuthenticationRequired);
        };
    }, []);

    useEffect(() => {
        if(!isLocalHostPreview || !localPreviewPath || !localPreviewPath.startsWith("/")){
            return;
        }

        const nextParams = new URLSearchParams(URLSearchParamsValue.toString());
        nextParams.delete("previewPath");
        const nextSearch = nextParams.toString();

        navigate({
            pathname: localPreviewPath,
            search: nextSearch ? `?${nextSearch}` : "",
        }, { replace: true });
    }, [isLocalHostPreview, localPreviewPath, navigate, URLSearchParamsValue]);

    useEffect(() => {
        const nextSearch = getSearchWithoutPreviewDeviceParams(location.search);

        if(nextSearch === null){
            return;
        }

        navigate({
            pathname: location.pathname,
            search: nextSearch,
            hash: location.hash,
        }, { replace: true });
    }, [location.hash, location.pathname, location.search, navigate]);

    useEffect(() => {
        if(typeof window === "undefined" || typeof document === "undefined"){
            return;
        }

        const tabletMediaQuery = window.matchMedia(RESPONSIVE_PREVIEW_TABLET_QUERY);
        const applyResponsivePreviewDevice = () => {
            document.documentElement.dataset.previewDevice = tabletMediaQuery.matches ? "tablet" : "mobile";
        };

        applyResponsivePreviewDevice();

        if(typeof tabletMediaQuery.addEventListener === "function"){
            tabletMediaQuery.addEventListener("change", applyResponsivePreviewDevice);
        }else{
            tabletMediaQuery.addListener(applyResponsivePreviewDevice);
        }

        return () => {
            if(typeof tabletMediaQuery.removeEventListener === "function"){
                tabletMediaQuery.removeEventListener("change", applyResponsivePreviewDevice);
            }else{
                tabletMediaQuery.removeListener(applyResponsivePreviewDevice);
            }

            delete document.documentElement.dataset.previewDevice;
        };
    }, [])

    // ?묒냽??二쇱냼??push_id媛 ?덈떎硫? ?대떦 媛믪쓣 ?쒕쾭濡?蹂대깂
    useEffect(() => {
        pushIdResponse();
    }, [URLSearchParamsValue])

    // react-photoswipe-gallery??紐⑤떖???ㅻ줈媛湲곕? ?듯빐 ?リ쾶?섍린 ?꾪빐 ?꾩뿭?쇰줈 ?좎뼵
    useEffect(() => {
        const onPopState = () => {
            const pswpEl = document.querySelector('.pswp');

            if (pswpEl && pswpEl.classList.contains('pswp--open')) {
                // PhotoSwipe ?대????リ린 踰꾪듉 ?대┃???몃━嫄?
                const closeBtn = pswpEl.querySelector('.pswp__button--close') as HTMLElement;
                closeBtn?.click();
            }
        };

        window.addEventListener('popstate', onPopState);

        return () => {
            window.removeEventListener('popstate', onPopState);
        };
    }, []);

    // 釉뚮씪?곗? ?섍꼍 媛먯?
    const l_browserCode = whichBrowserDoYouUse();
    if(l_browserCode === BROWSER_CODE.KakaoTalk || l_browserCode === BROWSER_CODE.LINE){
        return(
            <div className={[CSS.App].join(" ")}>
                <RedirectToAnotherBrowser />
            </div>
        )
    }

    // ?섏씠吏???묎렐 紐삵븯寃?留됱쓬
    if(l_isMaintenancePageOn){
        return(
            <div className={[CSS.App].join(" ")}>
                <div
                    className={CSS.l_container}
                    ref={containerRef}
                >
                    <main className={CSS.l_main_contents}>
                        <Routes>
                            <Route path="/maintenancePage" element={<MaintenancePage />} />
                            <Route path='*' element={<Navigate replace to='/maintenancePage' />} />
                        </Routes>
                    </main>
                </div>
            </div>
        )
    }else if (pageRouterCode === pageRouterCode_obj.customer) {

        // 怨좉컼 濡쒓렇???섏씠吏

        return (
            <>
                <div className={CSS.App}>
                    {/* ?ㅻ퉬寃뚯씠???뱀뀡 */}
                    {!isFigmaFullScreenRoute && (
                        <div className={[CSS.NaviSection, "NaviSection"].join(" ")}>
                        {/* ?ㅼ씠寃뚯씠??硫붾돱 */}
                            <CustomerNavi />
                        </div>
                    )}

                    {/* 而⑦뀗痢??뱀뀡 */}
                    <div className={[CSS.ContantsSection, "ContantsSection"].join(" ")}>
                        {/* ?ㅻ뜑 */}
                        {!isFigmaFullScreenRoute && (
                            <Header
                                headerLeftNode={headerLeftNode}
                                headerRightNode={headerRightNode}
                                mobileHeaderTitle={mobileHeaderTitle}
                                headerBackgroundColorPreset={headerBackgroundColorPreset}
                            />
                        )}

                        {/* 硫붿씤 而⑦뀗痢??곸뿭 */}
                        <div className={[CSS.MainSection, "MainSection", isFigmaFullScreenRoute ? CSS.FigmaFullScreenMain : ""].join(" ")}>

                            <ErrorBoundary>
                                {/* ?쇱슦??*/}
                                <Routes>
                                    {/* <Route path="/" element={<MainHome />} /> */}
                                    <Route path="/" element={<Navigate replace to="/tabs/home" />} />
                                    <Route path="/mobile" element={<Navigate replace to="/tabs/home" />} />
                                    <Route path="/tablet" element={<Navigate replace to="/tabs/home" />} />
                                    <Route path="/myHome" element={<Navigate replace to="/tabs/home" />} />
                                    <Route path="/tabs/home" element={<FigmaHomePage onNavigate={(target: string) => { navigate(target); }} />} />

                                    <Route path="/myPage" element={<Navigate replace to="/tabs/mypage" />} />
                                    <Route path="/tabs/mypage" element={<FigmaMyPage />} />
                                    <Route path="/mypage/photos" element={<MyPhotoArchivePage />} />
                                    <Route path="/mypage/contract-docs" element={<MobileMyPageDocuments mode="contract" />} />
                                    <Route path="/mypage/payment-history" element={<MobileMyPageDocuments mode="payments" />} />
                                    <Route path="/mypage/receipts" element={<MobileMyPageDocuments mode="receipts" />} />
                                    <Route path="/mypage/app-settings" element={<AppSettingsPage />} />
                                    <Route path="/mypage/terms" element={<TermsPage />} />
                                    <Route path="/changePassword" element={<ChangePassword />} />
                                    <Route path="/myInfo" element={<MyInfo />} />
                                    <Route path="/qnaList" element={<QnaList />} />
                                    <Route path="/qnaList/:postPk" element={<QnaList />} />
                                    <Route path="/qnaList/write" element={<QnaList />} />
                                    <Route path="/qnaList/write/:postPk" element={<QnaList />} />
                                    <Route path="/faqList" element={<FaqList />} />

                                    <Route path="/reservationHome" element={<Navigate replace to="/tabs/schedules" />} />
                                    <Route path="/tabs/schedules" element={<FigmaShootingSchedulePage />} />
                                    <Route path="/selectTheme" element={<Navigate replace to="/tabs/themes" />} />

                                    <Route path="/photoList" element={<Navigate replace to="/mypage/photos" />} />
                                    <Route path="/photoDetail" element={<Navigate replace to="/mypage/photos" />} />

                                    <Route path="/productList" element={<FigmaProductApplyPage />} />
                                    <Route path="/tabs/products" element={<FigmaProductApplyPage />} />
                                    <Route path="/productDetail" element={<Navigate replace to={getLegacyProductRedirect(location.search)} />} />
                                    <Route path="/productConfirm" element={<Navigate replace to={getLegacyProductRedirect(location.search)} />} />
                                    <Route
                                        path="/productRequestEdit"
                                        element={
                                            <ProductPhotoSelectPage
                                                onBack={() => {
                                                    navigate("/productList");
                                                }}
                                            />
                                        }
                                    />

                                    <Route path="/themeBook" element={<Navigate replace to="/tabs/themes" />} />
                                    <Route path="/tabs/themes" element={<FigmaShootingThemePage />} />

                                    <Route path="/paymentHistory" element={<Navigate replace to="/mypage/payment-history" />} />

                                    {
                                        whatIsMode().is_not_product_mode_safe
                                        &&  <Route path="/test_page" element={<TestPage />} />
                                    }

                                    {
                                        whatIsMode().is_not_product_mode_safe
                                        &&  <Route path="/deleteM" element={<DeleteURL />} />
                                    }

                                    <Route path='*' element={<Navigate replace to='/tabs/home' />} />
                                </Routes>
                            </ErrorBoundary>

                        </div>
                    </div>
                </div>
                <Toast position={"top-center"}/>
            </>
        );


        // 濡쒓렇?명븳 ?щ엺??怨좉컼
        // return (
        //     <div className={CSS.App}>
        //         <Toast position={"top-center"}/>

        //         {/* ?ㅻ퉬寃뚯씠??諛?*/}
        //         {
        //             !isNaviHidden
        //             &&  <CustomerNavi />
        //         }

        //         <div
        //             className={CSS.l_container}
        //             ref={containerRef}
        //         >
        //             {
        //                 !isHeaderHidden
        //                 &&  <Header
        //                         headerLeftNode={headerLeftNode}
        //                         headerRightNode={headerRightNode}
        //                         mobileHeaderTitle={mobileHeaderTitle}
        //                         headerBackgroundColorPreset={headerBackgroundColorPreset}
        //                     />
        //             }

        //             <main className={CSS.l_main_contents}>
        //                 <ErrorBoundary>
        //                     {/* ?쇱슦??*/}
        //                     <Routes>
        //                         <Route path="/" element={<MainHome />} />
        //                         <Route path="/myHome" element={<MyHome />} />

        //                         <Route path="/myPage" element={<MyPage />} />
        //                         <Route path="/changePassword" element={<ChangePassword />} />

        //                         <Route path="/reservationHome" element={<ReservationHome />} />
        //                         <Route path="/selectTheme" element={<SelectTheme />} />

        //                         <Route path="/photoList" element={<PhotoListMain />} />
        //                         <Route path="/photoDetail" element={<PhotoDetail />} />

        //                         <Route path="/productList" element={<FigmaProductApplyPage />} />
        //                         <Route path="/productDetail" element={<ProductDetail />} />
        //                         <Route path="/productConfirm" element={<ProductConfirm />} />
        //                         <Route path="/productRequestEdit" element={<ProductPhotoSelectPage onBack={() => { window.location.href = "/productList"; }} />} />

        //                         <Route path="/themeBook" element={<ThemeBookHome />} />

        //                         <Route path="/paymentHistory" element={<PaymentHistory />} />

        //                         {
        //                             whatIsMode().is_not_product_mode_safe
        //                             &&  <Route path="/test_page" element={<TestPage />} />
        //                         }

        //                         {
        //                             whatIsMode().is_not_product_mode_safe
        //                             &&  <Route path="/deleteM" element={<DeleteURL />} />
        //                         }

        //                         <Route path='*' element={<Navigate replace to='/' />} />
        //                     </Routes>
        //                 </ErrorBoundary>
        //             </main>
        //         </div>
        //     </div>
        // );
    }else if(pageRouterCode === pageRouterCode_obj.admin){
        return (
            <div className={CSS.App}>
                <Toast position={"top-center"}/>

                <div
                    className={CSS.l_container}
                    ref={containerRef}
                >
                    {
                        !isHeaderHidden
                        &&  <Header
                                headerLeftNode={headerLeftNode}
                                headerRightNode={headerRightNode}
                                mobileHeaderTitle={mobileHeaderTitle}
                                headerBackgroundColorPreset={headerBackgroundColorPreset}
                            />
                    }

                    <main className={CSS.l_main_contents}>
                        <ErrorBoundary>
                            <Routes>
                                <Route path='/' element={<ThemeBookHome />} />
                                <Route path="/themeBook" element={<ThemeBookHome />} />
                                <Route path="/themeBookManagement" element={<ThemeBookManagement />} />

                                {
                                    whatIsMode().is_not_product_mode_safe
                                    &&  <Route path="/test_page" element={<TestPage />} />
                                }

                                {
                                    whatIsMode().is_not_product_mode_safe
                                    &&  <Route path="/deleteM" element={<DeleteURL />} />
                                }

                                <Route path='*' element={<Navigate replace to='/' />} />
                            </Routes>
                        </ErrorBoundary>
                    </main>
                </div>

                {
                    !isNaviHidden
                    &&  <AdminNavi />
                }
            </div>
        )
    }else if(pageRouterCode === pageRouterCode_obj.login){
        // 濡쒓렇???섏씠吏
        return (
            <div className={CSS.App}>
                <Toast position={"top-left"}/>
                <ErrorBoundary>
                    <Routes>
                        <Route path='/' element={<Login />} />
                        <Route path="/resetUserPassword" element={<ResetUserPassword />} />
                        <Route path="/deleteM" element={<DeleteURL />} />

                        {
                            whatIsMode().is_not_product_mode_safe
                            &&  <Route path="/test_page" element={<TestPage />} />
                        }

                        <Route path='*' element={<Login />} />
                    </Routes>
                </ErrorBoundary>
            </div>
        );
    }else{
        return (
            <div className={CSS.App}>
                <Toast position={"top-left"}/>
                <ErrorBoundary>
                    <Routes>
                        <Route path='*' element={null}/>
                    </Routes>
                </ErrorBoundary>
            </div>
        );
    }
}

export default App;









